export function stableSort<T>(array: any[], cmp: (a: T, b: T) => number) {
  const stabilizedThis = array.map(
    (el: any, index: number) => [el, index] as [T, number],
  );
  stabilizedThis.sort((a: any, b: any) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el: any) => el[0]);
}

export function desc<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getSorting<K extends keyof any>(
  order: 'asc' | 'desc',
  orderBy: K,
): (
  a: { [key in K]: number | string },
  b: { [key in K]: number | string },
) => number {
  return order === 'desc'
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}
